//@flow
import React from 'react'
import './styles.scss'

const Author = ({ name, unityID, tenant }) => {
  // console.log('tenant:', tenant)
  return (
            <span className='author' key={unityID}>
              <a
                href={tenant.key !== undefined ? `https://www.${tenant.key}.ch/author/${unityID}` : '#'}
              >
                <nobr>{name}</nobr>
              </a>
            </span>
  )
}

export class Authors extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
  }
  
  componentDidMount() {
   
  }

  render() {
    return <div className='authors'>
            {this.props.authors && this.props.authors.map((person, i) => {
              return (
                  <Author
                    name={this.props.authors[i].name}
                    unityID={this.props.authors[i].unityID}
                    tenant={this.props.tenant}
                    key={'author-'+i}
                  />
                )})
            }
          </div>
  }
}



             